<template>
  <v-dialog
    :width="width"
    v-model="visible"
    :persistent="persistent"
  >
    <v-card>
      <v-card-title class="headline">
        {{ title }}
      </v-card-title>

      <v-card-text
        v-html="message"
        v-if="useHTML"
      />
      <v-card-text v-else>
        {{ message }}
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          :color="cancelButtonColor"
          @click="cancel"
          tabindex="1"
        >
          {{ cancelButtonText }}
        </v-btn>
        <v-btn
          color="primary"
          @click="confirm"
          ref="archConfirmOk"
          tabindex="1"
        >
          {{ confirmButtonText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class ArchAlertDialog extends Vue {
  @Prop({ type: String, default: "" }) title?: string;
  @Prop({ type: String, default: "" }) message?: string;
  @Prop({ type: String, default: "warn" }) type?: string;
  @Prop({ type: Boolean, default: false }) persistent?: boolean;
  @Prop({ type: String, default: "Ok" }) confirmButtonText?: string;
  @Prop({ type: String, default: "primary" }) confirmButtonColor?: string;
  @Prop({ type: String, default: "error" }) cancelButtonColor?: string;
  @Prop({ type: String, default: "Cancel" }) cancelButtonText?: string;
  @Prop({ type: [String, Number], default: 300 }) width?: string | number;
  @Prop({ type: Boolean, default: false }) useHTML: boolean;
  $refs!: {
    archConfirmOk: HTMLFormElement
  };

  public visible = true;

  public confirm():void {
    this.visible = false;
    this.$emit("confirm");
  }

  public cancel(): void {
    this.visible = false;
    this.$emit("cancel");
  }
  mounted() {
    setTimeout(() => {
      this.$refs?.archConfirmOk?.$el?.focus();
    }, 50);
  }
}
</script>
